// extracted by mini-css-extract-plugin
var _1 = "White-moduleactive__d2Qqg";
var _2 = "White-modulebasic__fb4kO";
var _3 = "White-modulegrey__ekqmp";
var _4 = "White-modulewhite__XvXEW";
export { _1 as "active", _2 as "basic", _3 as "grey", _4 as "white" }
